'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeUsageTracker = makeUsageTracker;

var _makeInAppUsageTracker = require('./makeInAppUsageTracker');

var _makePublicUsageTracker = require('./makePublicUsageTracker');

function makeUsageTracker(_ref) {
  var messagesUtk = _ref.messagesUtk,
      _ref$inApp = _ref.inApp53,
      inApp53 = _ref$inApp === undefined ? false : _ref$inApp;

  return inApp53 ? (0, _makeInAppUsageTracker.makeInAppUsageTracker)({ messagesUtk: messagesUtk }) : (0, _makePublicUsageTracker.makePublicUsageTracker)({ messagesUtk: messagesUtk });
}


//////////////////
// WEBPACK FOOTER
// ./js/usage-tracking/factories/makeUsageTracker.js
// module id = 1230
// module chunks = 3